


import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
/**
 * MenuService
 * Manages the currently selected menu state as an observable so other components can react to changes.
 */
@Injectable({ providedIn: 'root' })
export class MenuService {
    selectedMenu$ = new BehaviorSubject<string | null>(null);
    /**
     * Update the selected menu.
     *
     * @param menu - The menu identifier to set as selected
     */
    setMenu(menu: string) {
        this.selectedMenu$.next(menu);
    }
}
